export const KEYBOARD_SHORTCUTS = [
  {
    title: 'essential-shortcuts',
    restricted: false,
    items: [
      {
        label: 'keyboard-shortcuts',
        key: ['Shift', '?'],
      },
      {
        label: 'close-popup',
        key: 'Esc',
      },
      {
        label: 'expand-navigation',
        key: '[',
      },
      {
        label: 'collapse-navigation',
        key: ']',
      },
      {
        label: 'search-or-find',
        key: 'f',
      },
      {
        label: 'switch-active-profile',
        key: 's',
      },
    ],
  },
  {
    title: 'navigating-data',
    restricted: false,
    items: [
      {
        label: 'previous-page',
        key: '&larr;',
      },
      {
        label: 'next-page',
        key: '&rarr;',
      },
    ],
  },
];
